import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0993b26a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "app",
    "data-server-rendered": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = _resolveComponent("router-view");
    const _component_newUserDialog = _resolveComponent("newUserDialog");
    const _component_certDialog = _resolveComponent("certDialog");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view),
        ($setup.show)
            ? (_openBlock(), _createBlock(_component_newUserDialog, { key: 0 }))
            : _createCommentVNode("", true),
        ($setup.show)
            ? (_openBlock(), _createBlock(_component_certDialog, { key: 1 }))
            : _createCommentVNode("", true)
    ]));
}
